module.exports = __webpack_public_path__ + "img/sqch.0013d3f.png";